'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import UILink from 'UIComponents/link/UILink';
import { getCanonicalAppContext } from '../../selectors/app';
import { getIsUngatedForHomepage } from '../../selectors/auth';
import { getServices } from '../../slices/serviceCatalogSlice';
import { getMultiSelectStorefrontFilters } from '../../slices/storefrontFiltersSlice';
import { fromFilterStateToLocation } from '../../utils/storefrontFilters';
import { getFullLocationUrl } from '../../utils/urls';

const BasePrerenderFilter = props => {
  const {
    filterKey,
    SelectComponent
  } = props,
        passThroughProps = _objectWithoutPropertiesLoose(props, ["filterKey", "SelectComponent"]);

  const filters = useSelector(getMultiSelectStorefrontFilters);
  const catalogServices = useSelector(getServices);
  const canonicalAppContext = useSelector(getCanonicalAppContext);
  const isUngatedForHomepage = useSelector(getIsUngatedForHomepage);
  const getFilterLink = useCallback(value => {
    const filtersLocation = fromFilterStateToLocation(Object.assign({}, filters, {
      [filterKey]: [value]
    }), catalogServices, isUngatedForHomepage);
    return getFullLocationUrl(filtersLocation, canonicalAppContext);
  }, [canonicalAppContext, catalogServices, filterKey, filters, isUngatedForHomepage]);
  const OptionRenderer = useCallback(({
    children,
    option
  }) => /*#__PURE__*/_jsx(UILink, {
    href: getFilterLink(option.value),
    use: "unstyled",
    children: children
  }), [getFilterLink]);
  return /*#__PURE__*/_jsx(SelectComponent, Object.assign({
    defaultOpen: true,
    optionComponent: OptionRenderer
  }, passThroughProps));
};

export default BasePrerenderFilter;